import axios from "../config/axios.v2";
import { CAREER_URL, careerByIdUrl } from "./career.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("careerService err::", err);
  throw err;
};

const CareerService = {
  getAll: (params) => axios.get(CAREER_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(careerByIdUrl(id)).then(unwrap).catch(handleError),
  create: (payload) => axios.post(CAREER_URL, payload).then(unwrap).catch(handleError),
  update: (id, payload) => axios.patch(careerByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(careerByIdUrl(id)).then(unwrap).catch(handleError)
};

export default CareerService;
